import { render } from "./OAlert.vue?vue&type=template&id=bfd86664"
import script from "./OAlert.vue?vue&type=script&lang=js"
export * from "./OAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__